import React from "react";
import AcademiesContent from "../FunctionComponents/AcademiesFolder/AcademiesContent";

function Academies() {
  return (
    <>
      <AcademiesContent />
    </>
  );
}

export default Academies;
